export default {
  path: '/ev_charging_station_comments',
  component: () => import('@/layouts/PublicLayout'),
  redirect: '/ev_charging_station_comments/list',
  children: [
    {
      path: 'user_list',
      component: () => import('@/views/ev_charging_station_comments/UserComments'),
      meta: {
        title: '我的点评及回复'
      }
    }
  ]
}
